import localDB from "./localDB";

let GLOBAL = require('./globals');

const ChartsData = {
    async getSales(branch_office, time, date) {
        let response = await fetch(`${GLOBAL.BASE_URL}charts/sales/${time === 'd' ?'day':'all'}/${branch_office}?time=${time}&date=${date}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken(),
            }
        });
        return await response.json();
    },
    async getExpenses(branch_office, time, date) {
        let response = await fetch(`${GLOBAL.BASE_URL}charts/expenses/${time === 'd' ?'day':'all'}/${branch_office}?time=${time}&date=${date}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async getUtilities(branch_office, time, date) {
        let response = await fetch(`${GLOBAL.BASE_URL}charts/utilities/all/${branch_office}?time=${time}&date=${date}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async getProductSales(branch_office, time, date) {
        let response = await fetch(`${GLOBAL.BASE_URL}charts/product-sales/${branch_office}?date=${date}&time=${time}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async getStockBranchOffice(branch_office) {
        let response = await fetch(`${GLOBAL.BASE_URL}charts/stock-branch-office/${branch_office}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async getExpenseTypes(branch_office, time, date) {
        let response = await fetch(`${GLOBAL.BASE_URL}charts/expense-types/${branch_office}?date=${date}&time=${time}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async getSaleTypes(branch_office, time, date) {
        let response = await fetch(`${GLOBAL.BASE_URL}charts/sale-types/${branch_office}?date=${date}&time=${time}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async getSalesByCategories(branch_office, time, date) {
        let response = await fetch(`${GLOBAL.BASE_URL}charts/categories/${branch_office}?date=${date}&time=${time}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async getSalesByChannel(branch_office, time, date) {
        let response = await fetch(`${GLOBAL.BASE_URL}charts/channel/${branch_office}?date=${date}&time=${time}`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
};

export default ChartsData;



// WEBPACK FOOTER //
// ./src/data/ChartsData.js